'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { styled } from '@mui/material/styles';
const StyledHighlightSpan = styled('span')(({ theme }) => ({
    backgroundColor: theme.tokens.FuelColorGreen400
}));
export const StyledTruncateSpan = styled('span')({
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
export const Highlight = ({ inputValue, label, ...props }) => {
    if (inputValue) {
        const matches = match(String(label), inputValue, {
            insideWords: true
        });
        const parts = parse(String(label), matches);
        return (_jsx(StyledTruncateSpan, { ...props, children: parts.map((part, index) => part.highlight ? _jsx(StyledHighlightSpan, { children: part.text }, index) : _jsx("span", { children: part.text }, index)) }));
    }
    return _jsx(StyledTruncateSpan, { ...props, children: label });
};
